'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Skeleton_web = require('../../atoms/Skeleton/Skeleton.web.cjs');
var Typography_web = require('../../atoms/Typography/Typography.web.cjs');
var Price_web_styles = require('./Price.web.styles.cjs');

/**
 * Displays the cost of a product or service.
 *
 * @scope Web
 */ const Price = ({ msrp, sellPrice, isBold = false, type = "retail", isLoading = false, ...rest })=>{
    const formattedMsrp = `$${Number(msrp).toFixed(2)}`;
    const formattedSellPrice = /*#__PURE__*/ jsxRuntime.jsxs("span", {
        css: Price_web_styles.successText,
        children: [
            "$",
            Number(sellPrice).toFixed(2)
        ]
    });
    if (isLoading) return /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
        type: "typography"
    });
    if (type === "wholesale" && sellPrice) {
        return /*#__PURE__*/ jsxRuntime.jsxs(Typography_web.Typography, {
            customCss: Price_web_styles.strong,
            children: [
                /*#__PURE__*/ jsxRuntime.jsx("strong", {
                    children: formattedSellPrice
                }),
                " ",
                /*#__PURE__*/ jsxRuntime.jsxs("span", {
                    css: Price_web_styles.wholesaleMSRP,
                    children: [
                        "Wholesale | MSRP ",
                        formattedMsrp
                    ]
                })
            ]
        });
    }
    if (type === "blurred") {
        return /*#__PURE__*/ jsxRuntime.jsxs(Typography_web.Typography, {
            customCss: Price_web_styles.strong,
            children: [
                /*#__PURE__*/ jsxRuntime.jsx("span", {
                    css: Price_web_styles.blur,
                    "data-testid": "blurred",
                    children: formattedMsrp
                }),
                ` (MSRP)`
            ]
        });
    }
    const renderMsrpPrice = ()=>{
        if (sellPrice && sellPrice !== msrp) {
            return /*#__PURE__*/ jsxRuntime.jsx("s", {
                "data-testid": "strike",
                children: formattedMsrp
            });
        }
        if (isBold) {
            return /*#__PURE__*/ jsxRuntime.jsx("strong", {
                children: formattedMsrp
            });
        }
        return formattedMsrp;
    };
    const renderSellPrice = ()=>{
        if (sellPrice && sellPrice !== msrp) {
            if (isBold) {
                return /*#__PURE__*/ jsxRuntime.jsx("strong", {
                    children: formattedSellPrice
                });
            }
            return formattedSellPrice;
        }
    };
    return /*#__PURE__*/ jsxRuntime.jsxs(Typography_web.Typography, {
        customCss: Price_web_styles.strong,
        ...rest,
        children: [
            renderMsrpPrice(),
            " ",
            renderSellPrice()
        ]
    });
};

exports.Price = Price;
//# sourceMappingURL=Price.web.cjs.map
